<template>
  <div class="stok" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Stok</h2>

      <br />

      <div class="filter-bar">
        <div class="form-group">
          <label for="">Cari bahan baku</label>
          <input
            type="text"
            placeholder="Cari..."
            v-model="filter.nama"
            @keyup.enter="filterData()"
          />
        </div>
        <div>
          <label for="">&nbsp;</label>
          <button
            type="button"
            class="btn-outline"
            @click="exportExcel"
            :disabled="loadingExcel"
          >
            Export Excel
          </button>
        </div>
      </div>

      <div class="table-wrapper">
        <table class="table">
          <thead>
            <tr>
              <th>Barang</th>
              <th>Total Stok Masuk</th>
              <th>Total Stok Keluar</th>
              <th>Stok Sekarang</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in data"
              :key="index"
              @click="$router.push('/inventory/detail/' + item.id)"
            >
              <td>{{ item.nama }}</td>
              <td>{{ item.stok_masuk.jumlah | decimal }} {{ item.satuan }}</td>
              <td>{{ item.stok_keluar.jumlah | decimal }} {{ item.satuan }}</td>
              <td>
                {{
                  (parseFloat(item.stok_masuk.jumlah) -
                    parseFloat(item.stok_keluar.jumlah))
                    | decimal
                }}
                {{ item.satuan }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../api/Api";
import Search from "../icons/Search.vue";
import Close from "../icons/Close.vue";

export default {
  name: "BahanBaku",
  components: {
    Search,
    Close,
  },
  data() {
    return {
      loading: false,
      loadingExcel: false,
      data: [],
      tmpData: [],
      filter: {},
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      api
        .get("/v4/stok?id_toko=" + this.$toko.id)
        .then((r) => {
          this.loading = false;
          this.tmpData = r.data;
          this.data = this.tmpData;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },
    filterData() {
      if (this.filter.nama) {
        this.data = this.data.filter((k) => {
          return k.nama.toLowerCase().includes(this.filter.nama);
        });
      } else {
        return (this.data = this.tmpData);
      }
    },
    exportExcel() {
      if (this.data.length <= 0) {
        this.$toast("Tidak ada data untuk didownload");
        return;
      }

      this.loadingExcel = true;
      api
        .get("/v1/bahan-baku/export-excel?id_toko=" + this.$toko.id)
        .then((r) => {
          this.loadingExcel = false;
          if (r.valid) {
            location.href = r.filename;
          }
        })
        .catch((e) => {
          this.loadingExcel = false;
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.stok {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .filter-bar {
    display: flex;
    justify-content: space-between;
    input {
      width: 240px;
    }
  }

  .table-wrapper {
    height: calc(100vh - 290px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/stok/SemuaStok.vue